var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenVector = function SvgGreenVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 497,
    viewBox: "0 0 745 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M729.783 356.393C631 147.5 297.241 -146.945 136 85.5004C-25.2405 317.946 -73.8135 409.535 162.719 449.933C399.252 490.331 828.566 565.286 729.783 356.393Z",
    fill: "#ABDBD5",
    fillOpacity: 0.15
  })));
};
export default SvgGreenVector;